import $ from "jquery";

function TextCopy() {
  $(".js-text-copy").on("click", function () {
    const target = $(".js-text-copy-target").val();

    navigator.clipboard
      .writeText(target)
      .then(function () {
        $(".js-toast").fadeIn();
        setTimeout(function () {
          $(".js-toast").fadeOut();
        }, 6000);
      })
      .catch(function () {
        $(".js-toast-error").fadeIn();
        setTimeout(function () {
          $(".js-toast-error").fadeOut();
        }, 6000);
      });
  });

  setTimeout;
}

export { TextCopy };
